import { FC } from 'react'
import { formatDateWithLocale } from '../utils/intl'
import { useRecoilValue } from 'recoil'
import { currentUserState } from '../utils/state-atoms'
import { Link } from 'react-router-dom'

export const getMessageStatus = (message: any) => {
  const eventType: string = message.eventType
  const exitCode: number | undefined | null = message.platformremotecommand?.resultcode
  switch (eventType) {
    case 'ACK':
    case 'STATUS':
    case 'INFO':
    case 'LIC_CHECK':
      return 0
    case 'NACK':
      return 1
    case 'PROCESS_TERM':
      return exitCode === 0 ? 2 : 1
    default:
      return exitCode ? 3 : 1
  }
}


const statusName = [
  'In Progress',  // green
  'Error', // red
  'Complete', // gray
  'Unspecified', // gray
]

const statusColor = [
  '#498433',  // green
  '#E81919', // red
  '#0068BB', // blue
  '#ADADAD', // gray
]

const statusBgColor = [
  '#EDF3EB',
  '#FFE8E8',
  '#F6FAFE',
  '#EFEFEF',
]

type NotificationLineProps = {
  notification: any
}

type NotificationStatusProps = {
  status: number
}

const StatusBubble: FC<NotificationStatusProps> = ({ status }: NotificationStatusProps) => {
  const color = statusColor[status]
  const bgColor = statusBgColor[status]

  return (
    <div className="flex items-center px-2 py-1 space-x-1 rounded-full" style={{ backgroundColor: bgColor }}>
      <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: color }}></div>
      <div className="ml-2 text-xs" >{statusName[status]}</div>
    </div>
  )
}

const NotificationLine: FC<NotificationLineProps> = ({ notification }: NotificationLineProps) => {
  const { message, status, timestamp, gmref, eventType } = notification
  const color = statusColor[status]
  const currentUser = useRecoilValue(currentUserState)

  return (
    <div className="flex flex-col items-stretch border-l-4 border-solid space-y-1 py-1" style={{ borderLeftColor: color }}>
      <div className="flex items-center pl-1 space-x-10">
        <div className="basis-0 grow">{message}</div>
        <StatusBubble status={status} />
      </div>
      <div className="flex items-center pl-1 justify-between text-sm">
        <div>{eventType}</div>
        <div>{formatDateWithLocale(timestamp, currentUser.locale)}</div>
        <div>{`Run Group: ${gmref.rungroupid}`}</div>
        <Link target="_blank" to={`/submissions/${gmref.workflowsubmissionid}`} className="text-gm-blue">
          Run ID: {gmref.workflowsubmissionid}
        </Link>
      </div>
    </div >
  )
}

export default NotificationLine
